"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importStar(require("../../../styled"));
var __1 = require("../../../");
var avatar_1 = __importStar(require("../../../atoms/avatar"));
var text_1 = require("../../../atoms/text");
var tokens_1 = require("../../../tokens");
var automation_attribute_1 = __importDefault(require("../../../_helpers/automation-attribute"));
var action_builder_1 = require("../action-builder");
var itemFocusOutline = '2px';
var resolveAction = function (item, action, key) {
    if (typeof action === 'object' && !React.isValidElement(action)) {
        return action_builder_1.buttonBuilder(action_builder_1.actionToButtonProps(__assign({}, action, { key: key }), item));
    }
    var handler = action.props.onClick;
    var onClick = function (evt) {
        evt.stopPropagation();
        handler(evt, item);
    };
    return React.cloneElement(action, { key: key, onClick: onClick });
};
var resolveActions = function (actions, item) {
    return actions.map(resolveAction.bind(_this, item));
};
var ListItem = (function (_super) {
    __extends(ListItem, _super);
    function ListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dragHandler = React.createRef();
        return _this;
    }
    ListItem.prototype.renderSortingHandler = function () {
        if (this.props.reorderHandle) {
            var SortableHandler = this.props.reorderHandle;
            return React.createElement(SortableHandler, { ref: this.dragHandler });
        }
        return null;
    };
    ListItem.prototype.renderImage = function () {
        if (this.props.image) {
            return React.createElement(avatar_1.default, { type: "resource", image: this.props.image, size: "large" });
        }
        else if (this.props.icon) {
            return React.createElement(avatar_1.default, { type: "resource", icon: this.props.icon, size: "large" });
        }
        return null;
    };
    ListItem.prototype.renderTitle = function () {
        if (this.props.title) {
            if (this.props.href) {
                return React.createElement(__1.Link, { href: this.props.href }, this.props.title);
            }
            else {
                return this.props.title;
            }
        }
        return null;
    };
    ListItem.prototype.renderSubtitle = function () {
        return this.props.subtitle ? React.createElement(ListItem.Subtitle, null, this.props.subtitle) : null;
    };
    ListItem.prototype.renderActions = function () {
        return this.props.actions ? (React.createElement(__1.ButtonGroup, { align: "right" }, resolveActions(this.props.actions, this.props.item))) : null;
    };
    ListItem.prototype.render = function () {
        var props = this.props;
        var callHandler = function (handler) { return function (evt) { return handler(evt, props.item); }; };
        return (React.createElement(ListItem.Element, __assign({}, props, { draggingMode: props.draggingMode, onClick: props.onClick ? callHandler(props.onClick) : null }, automation_attribute_1.default('resource-list.item'), props),
            this.renderSortingHandler(),
            React.createElement(ListItem.Header, null,
                this.renderImage(),
                React.createElement("div", null,
                    this.renderTitle(),
                    this.renderSubtitle())),
            props.children && React.createElement(ListItem.Body, __assign({}, props), props.children),
            props.actions && React.createElement(ListItem.Footer, null, this.renderActions())));
    };
    ListItem.Element = styled_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid ", ";\n    padding: ", " ", ";\n    cursor: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n\n    &.cosmos-dragging {\n      background-color: ", ";\n      opacity: 0.9;\n      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n    }\n\n    > *:not(:last-child) {\n      margin-right: ", ";\n    }\n\n    /* Disable pointer events on non-dragging elements */\n    /* to avoid unexpected hover behaviors. */\n    ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    border-top: 1px solid ", ";\n    padding: ", " ", ";\n    cursor: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n\n    &.cosmos-dragging {\n      background-color: ", ";\n      opacity: 0.9;\n      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n    }\n\n    > *:not(:last-child) {\n      margin-right: ", ";\n    }\n\n    /* Disable pointer events on non-dragging elements */\n    /* to avoid unexpected hover behaviors. */\n    ",
        ";\n  "])), tokens_1.colors.list.borderColor, tokens_1.spacing.small, tokens_1.spacing.xsmall, function (props) { return (props.onClick ? 'pointer' : 'inherit'); }, tokens_1.colors.list.backgroundHover, tokens_1.colors.base.white, tokens_1.spacing.small, function (props) {
        return props.draggingMode
            ? styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            &:not(.cosmos-dragging) {\n              pointer-events: none;\n            }\n          "], ["\n            &:not(.cosmos-dragging) {\n              pointer-events: none;\n            }\n          "]))) : '';
    });
    ListItem.Header = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    word-break: break-word;\n\n    ", " {\n      /* This is a magic number */\n      margin-right: 12px;\n    }\n  "], ["\n    flex: 1;\n    display: flex;\n    align-items: center;\n    word-break: break-word;\n\n    ", " {\n      /* This is a magic number */\n      margin-right: 12px;\n    }\n  "])), avatar_1.StyledAvatar);
    ListItem.Body = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex: 1;\n    flex-basis: ", ";\n\n    /* This is not mobile first, but it avoids negation of margin */\n    @media screen and (max-width: 768px) {\n      flex: 1 0 100%;\n      order: 1;\n      margin-top: ", ";\n    }\n  "], ["\n    flex: 1;\n    flex-basis: ", ";\n\n    /* This is not mobile first, but it avoids negation of margin */\n    @media screen and (max-width: 768px) {\n      flex: 1 0 100%;\n      order: 1;\n      margin-top: ", ";\n    }\n  "])), function (props) { return props.bodyWidth; }, tokens_1.spacing.small);
    ListItem.Footer = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
    ListItem.Subtitle = styled_1.default(text_1.StyledTextAllCaps)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: block;\n  "], ["\n    margin-top: ", ";\n    display: block;\n  "])), tokens_1.spacing.xxsmall);
    return ListItem;
}(React.Component));
exports.default = ListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=item.js.map